export const BoostedWheelTheme = {
  IChancy: 999,
  Bet55: 427
};

// export const BoostedWheelTheme = {
//   IChancy: 552,
//   Bet55: 366
// };